export default __webpack_public_path__ + "static/media/ironman.f6a465b4.jpg";